import * as util from '../styles.util';
import {MxStyleObject, ServerStyleObject} from '../styles.model';
import {StyleKeeper} from './style-keeper.model';

export class ConnectorStyleKeeper implements StyleKeeper {
  constructor(
    private styles: ServerStyleObject,
    private connectorObj: any
  ) {}

  public original() {
    return this.styles;
  }

  public mxCellCss() {
    const result = <MxStyleObject>{};

    result['html'] = 1;
    result['shape'] = 'doubleEllipse';
    result['cloneable'] = 0;
    result['whiteSpace'] = 'wrap';
    result['fillColor'] = this.styles.mainColor;
    result['strokeColor'] = this.styles.secondaryColor;
    result['editable'] = 0;
    result['rotatable'] = 0;
    result['resizable'] = 0;

    return util.objectToString(result, '=');
  }
}
